module.exports = __webpack_public_path__ + "img/horizontal_6_6_pp1_3016.0d5ba21b.png";